import log from 'loglevel';
import React, { useState, useEffect } from 'react';
import { usePlayerContext } from '../Context';
import { Events, State, ToggleControlsChangedEvents } from '../../types/player';
import { StateChangedEvents } from '../../sdk/PlayerEvents';

const Poster = () => {
  const { sdk } = usePlayerContext();
  const [show, setShow] = useState(true);
  const prefix = sdk.getClassNamePrefix();
  const poster = sdk.options().getPoster();

  if (!poster) return null;

  useEffect(() => {
    sdk.on(Events.STATE_CHANGED, (event: StateChangedEvents) => {
      if (event.newState == State.PLAYING) {
        if (show === true)
          sdk.toggleControlsChanged(ToggleControlsChangedEvents.SHOW);
        setShow(false);
      }
    });
  }, []);

  if (!show) return null;

  return (
    <div
      className={`${sdk.getClassNamePrefix()}-player-poster`}
      style={{
        backgroundImage: `url(${poster})`,
        backgroundColor: sdk.options().getBgColor(),
        backgroundSize: sdk.options().getPosterFit(),
      }}
    />
  );
};

export default Poster;
